// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YouTubePreview__container-ded69c {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  overflow: hidden;
  cursor: pointer;
  background-size: cover;
  background-color: inherit;
}

.YouTubePreview__image-d66667 {
  position: relative;
  max-height: 100%;
  max-width: 100%;
  background-color: inherit;
}

.YouTubePreview__play-button-c0438b {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset-inline-start: 50%;
  top: 50%;
  width: 48px;
  height: 48px;
  transform: translate(-50%, -50%);
  background-color: var(--addition-40_60);
  color: var(--addition-50);
  border-radius: 50%;
  cursor: pointer;
}

.YouTubePreview__play-icon-d6b389 {
  fill: var(--addition-50);
}

.YouTubePreview__video-af1bda {
  position: absolute;
  inset-inline-start: 0px;
  top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/YouTubePreview/YouTubePreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,uCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,QAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n  background-size: cover;\n  background-color: inherit;\n}\n\n.image {\n  position: relative;\n  max-height: 100%;\n  max-width: 100%;\n  background-color: inherit;\n}\n\n.play-button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  inset-inline-start: 50%;\n  top: 50%;\n  width: 48px;\n  height: 48px;\n  transform: translate(-50%, -50%);\n  background-color: var(--addition-40_60);\n  color: var(--addition-50);\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.play-icon {\n  fill: var(--addition-50);\n}\n\n.video {\n  position: absolute;\n  inset-inline-start: 0px;\n  top: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `YouTubePreview__container-ded69c`,
	"image": `YouTubePreview__image-d66667`,
	"play-button": `YouTubePreview__play-button-c0438b`,
	"playButton": `YouTubePreview__play-button-c0438b`,
	"play-icon": `YouTubePreview__play-icon-d6b389`,
	"playIcon": `YouTubePreview__play-icon-d6b389`,
	"video": `YouTubePreview__video-af1bda`
};
module.exports = ___CSS_LOADER_EXPORT___;
